<template>
  <div>
    <b-card style="position: relative">
      <div v-if="$store.getters['containerAreaPlan.form/isLoading']" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>
        <b-row>
          <b-col cols="12">
            <plan-form />
          </b-col>
          <b-col cols="12">
            <b-button 
              v-ripple.400="'rgba(255, 255, 255, 0.15)'" 
              v-on:click="() => $store.dispatch('containerAreaPlan.form/update')"
              variant="primary" 
              class="mr-1"
            >
              {{ $t('FORM_SAVE_LABEL') }}
            </b-button>
          </b-col>
        </b-row>
    </b-card>

  </div>
</template>

<script>

import { OrbitSpinner } from 'epic-spinners'

import { 
  BButton, 
  BCard, 
  BCol, 
  BForm, 
  BFormGroup, 
  BFormInput,
  BInputGroup, 
  BRow, 
  BAlert, 
  BTabs, 
  BTab, 
  BCardText
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import planForm from '../share/form'
import StoreModule from '@/app/plans/containerArea/form.store.js'

export default {
  components: {
    planForm,
    BRow,
    BCard,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner
  },
  directives: {
    Ripple
  },
  setup( props, { root }) {

    const STORE_MODULE = 'containerAreaPlan.form'
    store.registerModule(STORE_MODULE, StoreModule)

    store.commit('containerAreaPlan.form/updateRoot', root)

    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE))
          store.unregisterModule(STORE_MODULE)
    })

    store.dispatch('containerAreaPlan.form/loadFromRoute')

    return {}

  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

</style>
